import React from 'react';
import Link from 'components/Link';
import Tooltip from 'components/Tooltip';
import { useViewportMediaQuery } from 'hooks';
import TagManagerService from 'services/TagManager';
import style from './style.scss';

const FrequentProducts = () => {
    const isMobile = useViewportMediaQuery(1120);

    const _onClick = () => {
        TagManagerService.clickHeader('Variante 1', 'Productos Frecuentes');
    }

    return (
        <Link to="/productos-frecuentes" className="header-frequent-products">
            {isMobile && <Tooltip message='Mis productos favoritos' button='Entendido' timer={5000} once={true} type='tooltip_header_frequent_products'/>}

            <button className="header-frequent-products-button-wrap" onClick={_onClick}>
                <i className="jumbo-icon-frequent-product"></i>
                <span className="header-frequent-products-title">Frecuentes</span>
            </button>
        </Link>
    )
}

export default FrequentProducts